import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { StudentAddView } from '@/modules/students'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute(
  '/_auth/students-and-classes/students/add/'
)({
  component: StudentAddView,
  head: () =>
    getMetaWithPageTitle([i18n.t('title.add-new-student', { ns: 'students' })])
})
